
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import { OrderModule, SystemModule } from "@/store/modules/";
import notifications from "@/lib/notifications";
import * as modals from "@/lib/modals";
import DateRange from "../DateRange.vue";
import { CompletedOrderExportRequest } from "@/models/api/orders/completedOrderExport";
import Select from "@/components/form/Select.vue";
import { AccountModule } from "@/store/modules";

@Component({
  name: modals.completedOrderExportModal,
  components: { Select }
})
export default class CompletedOrderExportModal extends Mixins(mixin) {
  @Ref() readonly deliveryDateRange!: DateRange;

  accountModule: AccountModule = getModule(AccountModule);
  orderModule: OrderModule = getModule(OrderModule);
  systemModule: SystemModule = getModule(SystemModule);

  supportedFormats: any[] = [{ label: "CSV", value: "csv" }, { label: "Excel", value: "xlsx" }];
  deliveryDateRangeValue: any = null;
  pendingDownload: boolean = false;

  completedOrderExportRequest: CompletedOrderExportRequest = {
    format: null,
    deliveryDateStart: null,
    deliveryDateEnd: null,
    include: {
      scheduledDates: true,
      receiptDate: true,
      loadingDate: true,
      deliveryDate: true,
      documents: true,
      pods: true
    }
  };

  load() {
    this.show();
  }

  reset() {
    this.deliveryDateRangeValue = null;
    this.completedOrderExportRequest.format = null;
  }

  async exportDeliveries() {
    let dateRange = this.deliveryDateRange.dateRange;

    if (!dateRange) {
      notifications.error("File Export", "Please select a date range.");
      return;
    }

    if (!this.completedOrderExportRequest.format) {
      notifications.error("File Export", "Please select an export format.");
      return;
    }
    
    this.completedOrderExportRequest.deliveryDateStart = dateRange.start;
    this.completedOrderExportRequest.deliveryDateEnd = dateRange.end;

    try {
      this.pendingDownload = true;
      await this.orderModule.exportCompletedOrdersExport(this.completedOrderExportRequest);
      notifications.success("File Export", "Export completed successfully.");
    } catch (ex) {
      notifications.error("File Export", "Failed to export file", ex);
    } finally {
      this.pendingDownload = false;
    }
  }

  get exportDisabled() {
    return !this.deliveryDateRangeValue || !this.completedOrderExportRequest.format;
  }
}
